import { GradientText, RightIcon } from "lola-framework-ui-test";
import type { JSX } from "react";
import { renderBankAccountLine } from "../utils/bankAccountLine";

export interface PayoutInfoProps {
  title: string;
  subtitle: string;
  icon: JSX.Element;
  onChange?: () => void;
  background?: string;
  color?: string;
  fee?: string | JSX.Element;
  className?: string;
  /**
   * When true, the row is preselected and cannot be changed by the user:
   * it is not clickable and hides the change affordance (chevron).
   */
  locked?: boolean;
  /**
   * Saved instrument that cannot be used on this route. Stays clickable so
   * the picker can explain why — unlike `locked`, which swallows the tap.
   */
  unavailable?: boolean;
}

export const PayoutInfo: React.FC<PayoutInfoProps> = ({
  title,
  subtitle,
  icon,
  onChange = () => {},
  background = "#fff",
  color = "#252525",
  fee,
  className = "",
  locked = false,
  unavailable = false,
}) => {
  return (
    <section
      className={`payout-container-content ${locked ? "locked" : ""} ${unavailable ? "funding-unavailable" : ""} ${className}`.trim()}
      onClick={locked ? undefined : onChange}
      style={
        {
          "--bgc": background,
        } as React.CSSProperties
      }
    >
      <section className="payout-container-info">
        <section className="payout-icon-container">{icon}</section>
        <GradientText textColor={color} className="payout-text-info">
          {renderBankAccountLine(title)}
          {subtitle ? <label>{renderBankAccountLine(subtitle)}</label> : null}
        </GradientText>
      </section>
      {fee ? (
        fee
      ) : locked ? null : unavailable ? (
        <span
          className="funding-unavailable-info"
          aria-hidden="true"
          style={{ color }}
        >
          i
        </span>
      ) : (
        <RightIcon size={30} colors={[color, color]} />
      )}
    </section>
  );
};
